import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/claims-products/claims/general',
            params,
            replace: true,
        });
    },
});
